import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetAdPriceResponse } from "./adPrice.api";
import { GetAdPriceThunk } from "./adPrice.thunk";

export interface AdPriceStore {
  adPrice: GetAdPriceResponse;
  adPriceLoading: boolean;
}

export const InitialAdPriceState: AdPriceStore = {
  adPrice: { total_price: 0, discounted_amount: 0, final_price: 0 },
  adPriceLoading: false,
};

const AdPriceSlice = createSlice({
  name: "AdPriceSlice",
  initialState: InitialAdPriceState,
  reducers: {
    setAdPrice(state, action: PayloadAction<GetAdPriceResponse>) {
      state.adPrice = action.payload;
    },
    setAdPriceLoading(state, action: PayloadAction<boolean>) {
      state.adPriceLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetAdPriceThunk.fulfilled, (state, action) => {
      if (action.payload) {
        state.adPrice = action.payload;
      }
    });
  },
});

export const AdPriceActions = AdPriceSlice.actions;
export const AdPriceReducer = AdPriceSlice.reducer;
